import script from "./sideBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./sideBar.vue?vue&type=script&lang=ts&setup=true"

import "./sideBar.vue?vue&type=style&index=0&id=a41461f6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a41461f6"]])

export default __exports__